import React from 'react';

const StatsCard = ({ title, value, icon, color, subtext }) => {
    return (
        <div className="stats-card" style={{ 
            borderLeft: `none`, 
            padding: '24px',
            position: 'relative',
            overflow: 'hidden'
        }}>
            <div style={{
                position: 'absolute',
                top: '0',
                right: '0',
                width: '100px',
                height: '100px',
                background: `linear-gradient(135deg, ${color}10 0%, ${color}05 100%)`,
                borderRadius: '0 0 0 100%',
                zIndex: '0'
            }}></div>
            
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', zIndex: '1', position: 'relative' }}>
                <div className="stats-info">
                    <span style={{ 
                        fontSize: '13px', 
                        fontWeight: '600', 
                        color: 'var(--text-secondary)',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        display: 'block',
                        marginBottom: '8px'
                    }}>{title}</span>
                    <h3 style={{ 
                        fontSize: '24px', 
                        fontWeight: '800', 
                        color: 'var(--text-primary)',
                        margin: '0',
                        letterSpacing: '-0.5px'
                    }}>{value}</h3>
                    {subtext && <span style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '4px', display: 'block' }}>{subtext}</span>}
                </div>
                
                <div style={{ 
                    width: '48px', 
                    height: '48px', 
                    borderRadius: '12px', 
                    backgroundColor: `${color}15`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: color,
                    fontSize: '20px',
                    boxShadow: `0 4px 10px ${color}10`
                }}>
                    <i className={icon}></i>
                </div>
            </div>
        </div>
    );
};

export default StatsCard;
